/**
 * Accessibility utilities
 */

/**
 * Adds a title to links that open in a new window (target="_blank").
 * WCAG 2.2 AAA F22: https://www.w3.org/WAI/WCAG22/Techniques/failures/F22
 *
 * @param {string} containerSelector
 */
export function setNewWindowTitleOnLinks(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) {
        return;
    }

    const links = container.querySelectorAll('a[target="_blank"]');
    links.forEach((link) => {
        const note = 'opens in a new window';
        const existingTitle = link.getAttribute('title');
        if (existingTitle) {
            const alreadyHasNote = existingTitle.toLowerCase().includes(note);
            if (!alreadyHasNote) {
                link.setAttribute('title', `${existingTitle} (${note})`);
            }
        } else {
            link.setAttribute('title', 'Opens in a new window');
        }
    });
}

/**
 * Adds aria-labels to links with vague text (e.g., "click here").
 * WCAG 2.2 AAA F84: https://www.w3.org/WAI/WCAG22/Techniques/failures/F84
 *
 * @param {string} containerSelector
 * @param {string=} customAriaLabel
 */
export function setAriaLabelForVagueLinks(containerSelector, customAriaLabel) {
    const container = document.querySelector(containerSelector);
    if (!container) {
        return;
    }

    const phraseSet = new Set(['click here', 'here', 'read more', 'learn more']);
    const links = container.querySelectorAll('a');
    links.forEach((link) => {
        const visibleText = (link.textContent || '').trim();
        const textLower = visibleText.toLowerCase();
        if (phraseSet.has(textLower)) {
            const existingAriaLabel = link.getAttribute('aria-label');
            if (existingAriaLabel) {
                const includesVisibleText = existingAriaLabel.toLowerCase().includes(textLower);
                if (!includesVisibleText) {
                    const suffix = customAriaLabel || existingAriaLabel;
                    const ariaLabel = `${visibleText} — ${suffix}`;
                    link.setAttribute('aria-label', ariaLabel);
                }
            } else {
                const suffix = customAriaLabel || 'click this link for more information about this topic';
                const ariaLabel = `${visibleText} — ${suffix}`;
                link.setAttribute('aria-label', ariaLabel);
            }
        }
    });
}
